module.exports = __webpack_public_path__ + "static/media/scaled-large.9f33169e.webp";